import React from 'react';

import { SiteFooter } from '../../components/SiteFooter/SiteFooter';
import { RosterGrid } from './RosterGrid';
import { RosterHeaderSection } from './RosterHeaderSection';
import type { RosterPageData } from './types';

export function RosterPage({ csrfToken, header, initial }: RosterPageData) {
    return (
        <div className="roster-page">
            <main className="roster-page__main">
                <RosterHeaderSection data={header} />
                <RosterGrid initial={initial} />
            </main>
            <SiteFooter csrfToken={csrfToken} />
        </div>
    );
}
